// Components
import { Space } from 'antd';
import { Tooltip } from '../../../Tooltip';
import Slider from '../../../Slider';
import { VolumeIcon, VolumeMuteIcon, VolumeOneIcon, VolumeTwoIcon } from '../../../Icons';

// Redux
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { playingBarActions } from '../../../../store/slices/playingBar';

// I18n
import { useTranslation } from 'react-i18next';

const getIcon = (volume: number) => {
  if (volume === 0) return <VolumeMuteIcon />;
  if (volume < 0.4) return <VolumeOneIcon />;
  if (volume < 0.8) return <VolumeTwoIcon />;
  return <VolumeIcon />;
};

const VolumeControls = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['navbar']);
  const { muted, volume } = useAppSelector((state) => state.playingBar);

  const handleToggleMute = () => {
    if (muted || volume === 0) {
      // unmute → restore some volume (default 0.5)
      dispatch(playingBarActions.setVolume({ volume: 0.5 }));
    } else {
      // mute → set volume to 0
      dispatch(playingBarActions.setVolume({ volume: 0 }));
    }
  };

  return (
    <div className='flex flex-row items-center gap-2'>
      <Tooltip title={muted ? t('UNMUTE') : t('MUTE')}>
        <button
          onClick={handleToggleMute}
          className='icon-button'
          aria-label={muted ? t('UNMUTE') : t('MUTE')}
        >
          {getIcon(muted ? 0 : volume)}
        </button>
      </Tooltip>

      <Space>
        <div style={{ width: 93 }}>
          <Slider
            isEnabled
            value={muted ? 0 : volume}
            onChange={(value: number) => {
              dispatch(playingBarActions.setVolume({ volume: value }));
            }}
          />
        </div>
      </Space>
    </div>
  );
};

export default VolumeControls;
